import React, { useState, useEffect } from 'react'
import { shallowEqual, useSelector } from "react-redux";
import { Card, CardBody, CardHeader } from '../../../../../_metronic/_partials/controls'
import {
	Button,
	Checkbox,
	FormControlLabel,
	MuiThemeProvider,
	TextField,
	createMuiTheme
} from '@material-ui/core'
import { useSkeleton } from '../../../../hooks/useSkeleton'
import ConfirmDialog from "../../../../components/dialogs/ConfirmDialog";
import { alertError } from '../../../../../utils/logger';
import MyAutocomplete from '../../../../components/MyAutocomplete';
import { EditFormInfo } from '../../../../../utils/formUtils';
import { changes, setChanges } from '../../../../../utils/globals';
import { Col, Row } from 'react-bootstrap';

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

function getEmptyForm() {
	return {
		date: null,
		schedule: null,
		active: true
	}
}

function getEmptyExtraForm() {
	return {
		texts: [],
		tests: [],
		yesNo: []
	}
}

const scheduleOptions = ["1 week", "2 weeks", "4 weeks"];

export default function EditPatientForm(props) {
	const { data, setOpen, onDelete, onSave, newForm, allForms, patientForms } = props;
	const [form, setForm] = useState(getEmptyForm());
	const [extraForm, setExtraForm] = useState(getEmptyExtraForm());
	const [openConfirmDialog, setOpenConfirmDialog] = useState(0);
	const [refresh, setRefresh] = useState(false);
	const [availableForms, setAvailableForms] = useState([]);

	const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()
	const user = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	// const [changes, setChanges] = useState(-2);
	useEffect(() => setChanges(-2), []);
	useEffect(() => {
		if (changes <= 0) setChanges(changes+1);
	}, [form])

	useEffect(() => {
		if (data) {
			setForm(data);
			setExtraForm(data?.extraQuestions)
			disableLoadingData();
		} else setForm(getEmptyForm());
	}, [data, disableLoadingData])

	useEffect(() => {
		refreshAvailibleForms();
	}, [allForms])

	useEffect(() => {
		setRefresh(false);
	}, [refresh]);

	function refreshAvailibleForms() {
		if (!allForms) return;
		let newForms = [...allForms];

		for (let i = 0; i < patientForms.length; ++i) {
			const index = newForms.findIndex((x) => x._id === patientForms[i].form);
			if (index === -1) console.log("ERROR");
			newForms.splice(index, 1);
		}

		setAvailableForms(newForms);
	}
	
	const handleChange = (element, lang) => (event) => {
		setForm({ ...form, [element]: event.target.value })
	}

	function OriginalQuestions() {
		const completeForm = allForms?.find((x) => x._id === form?.form);

		const tests = completeForm?.tests;
		const texts = completeForm?.texts;
		const yesNo = completeForm?.yesNo;

		let concatQuestions = [];
		if (tests) for (let i = 0; i < tests?.length; ++i) concatQuestions.push({ ...tests[i], type: "TEST"});
		if (texts) for (let i = 0; i < texts?.length; ++i) concatQuestions.push({ ...texts[i], type: "TEXT"});
		if (yesNo) for (let i = 0; i < yesNo?.length; ++i) concatQuestions.push({ ...yesNo[i], type: "YES/NO"});

		concatQuestions.sort((a, b) => {
			const aN = parseFloat(a?.number);
			const bN = parseFloat(b?.number);
			if (aN > bN) return 1;
			if (aN < bN) return -1;
			return 0;
		})

		return (
			<>	
				<br />
				<br />
				<h5>Original questions</h5>
				{ concatQuestions.map((q, i) => {
					const questionText = `${q?.type} - ${q?.question}`
					return (
						<>
							<Row>
								<Col>
									<TextField
										id={`q${i}`}
										label={`Question ${q?.number}`}
										inputProps={{ readOnly: true }}
										value={questionText}
										margin="normal"
										variant="standard"
										type="text"
										className='readonly'
									/>
								</Col>
							</Row>
						</>
					)
				})}
			</>
		)
	}

	if (isLoadingData)
		return <ContentSkeleton />
	else return (
		<>
		<Card>
		<CardHeader title={"Edit form"}>
			<div className='mt-5'>
			<Button
				onClick={() => {
				if (changes > 0) setOpenConfirmDialog(1);
				else setOpen(false);
				}}
				variant="outlined"
				style={{ marginRight: '20px' }}>
				Back
			</Button>
			<Button
				onClick={async () => {
					if (!form?.form || !form?.date || !form.schedule) {
						alertError({
							error: "Error!",
							customMessage: "All fields are required."
						})
					} else {
						const saveForm = {
							...form,
							extraQuestions: { ...extraForm }
						}
						const res = await onSave(saveForm);
						if (res) setOpen(false);
					}
				}}
				variant="outlined"
				color="primary"
				style={{ marginRight: '20px' }}>
				Save form
			</Button>
			<ConfirmDialog
				title={
				"Are you sure you want to go back? You will lose all your changes"
				}
				open={openConfirmDialog === 1}
				setOpen={setOpenConfirmDialog}
				onConfirm={async () => {setOpen(false);}}
			/>
				{!newForm && user?.role.includes("admin") && (
					<>
					<MuiThemeProvider theme={theme}>
						<Button
						onClick={() => setOpenConfirmDialog(2)}
						variant="outlined"
						color="secondary"
						style={{ marginRight: "20px" }}
						>
						Delete form
						</Button>
						<div
						style={{
							display: "flex",
							flexDirection: "row",
							marginLeft: "auto",
						}}
						></div>
					</MuiThemeProvider>

					<ConfirmDialog
						title={
						"Are you sure you want to delete this form?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={async () => {
							const res = await onDelete(form);
							if (res) setOpen(false);
						}}
					/>
					</>
				)}
			</div>
		</CardHeader>
			<CardBody>

				{ newForm ? (
					<MyAutocomplete
						options={ availableForms }
						getOptionLabel={(option) => option.name}
						value={
							allForms?.find(
								(x) => x._id === form?.form
							) || null
						}
						onChange={(event, selected) => {
							setForm({...form, form: selected._id});
							setRefresh(true);
						}}
						placeholder="Select form"
						label={"Form"}
					/>
				) : (
					<TextField
						id={"form"}
						label={"Form"}
						value={
							allForms?.find(
								(x) => x._id === form?.form
							)?.name || null
						}
						InputLabelProps={{
						shrink: true
						}}
						inputLabelProps={{readonly: true}}
						margin="normal"
						variant="standard"
						type='text'
						className='readonly'
						required
					/>
				)}

				<TextField
					id={"Date"}
					label={"Initial date"}
					value={form?.date}
					onChange={handleChange("date")}
					InputLabelProps={{
					shrink: true
					}}
					margin="normal"
					variant="standard"
					type='datetime-local'
					required
				/>

				<MyAutocomplete
					options={ scheduleOptions }
					getOptionLabel={(option) => option}
					value={
						scheduleOptions?.find(
							(x) => x === form?.schedule
						) || null
					}
					onChange={(event, selected) => {
						setForm({...form, schedule: selected});
						setRefresh(true);
					}}
					placeholder="Select schedule"
					label={"Schedule"}
				/>
				<FormControlLabel
					control={
					<Checkbox
						checked={form?.active}
						onChange={() =>
						setForm({
							...form,
							active: !form?.active,
						})
						}
						name="checkActive"
					/>
					}
					label="Active"
				/>
				<br />
				<EditFormInfo form={extraForm} setForm={setExtraForm} extra={true}/>
				<OriginalQuestions />
			</CardBody>
		</Card>
		</>
	);
}
